<div mat-dialog-title>
  <div class="flex items-center justify-between h-48">
    <h6>{{ data?.user ? 'Edit User' : 'Add New User' }}</h6>
    <button matIconButton aria-label="Close" mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>
<mat-divider class="mx-20!" />
<form (ngSubmit)="saveUpdateUser()" [formGroup]="addUserForm">
  <div mat-dialog-content>
    <div class="grid grid-cols-3 gap-x-20">
      <mat-form-field>
        <mat-label>Username</mat-label>
        <input formControlName="username" matInput required />
        @if (username.hasError('required')) {
          <mat-error> Username is <strong>required</strong> </mat-error>
        }
        @if (!username.valid && !username.hasError('required')) {
          <mat-error> This username already exists </mat-error>
        }
      </mat-form-field>
      <mat-form-field>
        <mat-label>First Name</mat-label>
        <input formControlName="firstName" matInput required />
        @if (firstName.hasError('required')) {
          <mat-error> First Name is <strong>required</strong> </mat-error>
        }
      </mat-form-field>
      <mat-form-field>
        <mat-label>Last Name</mat-label>
        <input formControlName="lastName" matInput required />
        @if (lastName.hasError('required')) {
          <mat-error> Last Name is <strong>required</strong> </mat-error>
        }
      </mat-form-field>
    </div>

    <div class="grid grid-cols-2 gap-x-20">
      <mat-form-field>
        <mat-label>Email</mat-label>
        <input formControlName="email" matInput required />
        @if (email.hasError('required')) {
          <mat-error> Email is <strong>required</strong> </mat-error>
        }
        @if (email.hasError('pattern') && !email.hasError('required')) {
          <mat-error class="mat-error"> Please enter a valid email address </mat-error>
        }
        @if (email.hasError('duplicate') && !email.hasError('required')) {
          <mat-error class="mat-error"> This email exists already in the system </mat-error>
        }
      </mat-form-field>
      <mat-form-field>
        <mat-label>Phone Number</mat-label>
        <input formControlName="phone" matInput />
        @if (phone.touched && phone.hasError('phoneInvalid')) {
          <mat-error> {{ getErrorMessage(phone.errors) }} </mat-error>
        }
      </mat-form-field>
    </div>

    @if (!data?.user?.privileges.includes('MLADMIN')) {
      <div class="grid grid-cols-3 gap-x-20">
        <mat-form-field>
          <mat-label>Permission</mat-label>
          <mat-select formControlName="permission">
            <mat-option value="User">Repairer</mat-option>
            <mat-option value="REPADMIN">Administrator</mat-option>
          </mat-select>
        </mat-form-field>
        @if (data?.user?.isActivated && data?.user?.status === 'ENABLED') {
          <div class="col-span-2">
            <mat-checkbox [checked]="primaryContact.value" formControlName="primaryContact">
              Primary Contact of this location
            </mat-checkbox>
            <div class="text-12 leading-16 text-charcoal-60 -mt-5 ml-35 w-[300px]">
              This person can be contacted by Stelvio to deal with issues related to your location
            </div>
          </div>
        }
        @if (!data?.user.isActivated) {
          <div class="email-info col-span-full mb-20">
            <mat-icon>error_outline</mat-icon>
            <span>An email will be sent to this email address to complete account information</span>
          </div>
        }
      </div>
    }
  </div>
  <mat-divider class="mx-20!" />

  <mat-dialog-actions>
    <button matButton="elevated" class="charcoal-button" type="button" mat-dialog-close>CANCEL</button>
    <button matButton="elevated" class="red-button" type="submit" [disabled]="addUserForm.invalid || pending()">
      {{ !data || !data?.user.isActivated ? 'INVITE' : 'SAVE' }}
    </button>
  </mat-dialog-actions>
</form>
